import { render, staticRenderFns } from "./LetterHistory.vue?vue&type=template&id=55c640b6"
import script from "./LetterHistory.vue?vue&type=script&lang=js"
export * from "./LetterHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports